import { CanvasCreditsPanel as Panel } from '@genieartinc/studio-ui'
import { useWalletBalance } from '@/hooks/useWalletBalance'
import { useSettingsStore } from '@/stores/useSettingsStore'

export function CanvasCreditsPanel() {
  const balance = useWalletBalance()
  const openSettings = useSettingsStore((state) => state.open)

  return (
    <Panel
      {...balance}
      onTopUp={() => openSettings('billing', { topUp: true })}
      onBilling={() => openSettings('billing')}
    />
  )
}
export { CanvasCreditsPanel as CanvasSidebarCredits }
